import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FaseCursoService {

    private readonly path = 'bolsa';
    public params = new HttpParams();

    constructor(private apiService: ApiService) { }

    list(params?: any): Observable<any[]> {// TODO: Mudar o any para o tipo correcto
        return this.apiService.get<{ data: any[] }>(`${this.path}/getAllCategoriaInstituicaoEnsino`, params ? new HttpParams({
            fromObject: params
        }) : this.params).pipe(
            map(response => response.data)
        );
    }

    public show(id: string): Observable<any> {
        return this.apiService.get<{ data: any, retorno: any }>(`${this.path}/getCategoriaInstituicaoEnsinoById/${id}`).pipe(
            map(response => response.data as any)
        );
    }

}